<template>
    <div class="wrap clearfix">
        <h2 v-if="this.settle_type == 1">전화처방 정산</h2>
        <h2 v-if="this.settle_type == 2">건강상담 정산</h2>

        <!-- <div class="btn-group clearfix">
            <p class="cnt-group">건수 : {{ total_count }} 건</p>
        </div> -->
        
        <div class="clearfix">
            <!-- 상단영역 -->
            <div class="top">
                <settle-top-list :top_settlements="top_settlements" @onSelectRow="onSelectRow"></settle-top-list>

                <!-- 페이징 -->
                <!-- 
                <div class="top-pager clearfix">
                    <span class="pager-next" @click="page_current>1?load_list(page_current-1):'#'" >&lt;</span>
                    <ul class="pager-list">
                        <li>{{page_current}}</li>
                    </ul>
                    <span id="ttt" class="pager-next" @click="is_paging?load_list(page_current+1):'#'">&gt;</span>
                </div> 
                -->
            </div>

            <!-- 하단영역 -->
            <div class="bottom">
                <div class="box">
                    <settle-bottom-tel-list :bottom_settlements="bottom_settlements" :searchParams="searchParams" @searchEvent="search" v-if="this.settle_type == 1"></settle-bottom-tel-list>
                    <settle-bottom-etc-list :bottom_settlements="bottom_settlements" :searchParams="searchParams" @searchEvent="search" v-if="this.settle_type == 2"></settle-bottom-etc-list>

                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import SettleTopList from '@/components/Settle/SettleTopList.vue'
import SettleBottomTelList from '@/components/Settle/SettleBottomTelList.vue'
import SettleBottomEtcList from '@/components/Settle/SettleBottomEtcList.vue'
import moment from 'moment-timezone';

export default {
    name: 'settle',
    data() {
        return {
            settle_type: this.$route.params.settle_type,

            top_settlements: [],
            bottom_settlements: [],
            chosen_settlement: {},

            //bottom list 검색(api) 파라미터
            searchParams: {
                date_type: '1',
                consult_status: '',
                settled: '',
                date_start: '',
                date_end: '',
                search_type: '',
                search: '',
                what_is: '',
            }
        }
    },
    computed: {
        ...mapState(['account']),
    },
    methods: {
        //async load_top_list (page_no = 1){
        async load_top_list(){
            //최근 3개월 조회 시작 날짜를 UTC 변환 -> 다시 한국시간으로 보내기로함
            let utcDate = moment().subtract(2, 'month').format('YYYY-MM');
            utcDate = moment(utcDate).format('YYYY-MM-DDTHH:mm:ss');
            // utcDate = moment(utcDate).utc().format('YYYY-MM-DDTHH:mm:ss');

            let params = {
                'consult_type': this.settle_type, //1. 전화처방, 2. 나머지
                'month': utcDate,
            }
            let today = new Date();
            let year = today.getFullYear();
            let month = today.getMonth() + 1;  // 월
            let date = today.getDate();  // 날짜
            let secure_key = (month + date) * 12;

            await this.axios({
                method: 'get',
                url: 'https://api-v2.mdtalk.io/settle/' + secure_key + '/month/' + this.account.dr_id + '/three/',
                params: params,
                headers: {'Authorization': 'Token 26c42293dd1fd5ed01320646e094196a827393f8'}
            }).then((response) => {
                this.top_settlements = response.data.resp;
            }).catch((error) => {
                console.log('error: ', error);
            });



        },

        async load_bottom_list(){
            
            //상담상태 검색 파라미터 _붙여서 보내기
            let consult_status_str = '';
            if(this.searchParams.consult_status && this.searchParams.consult_status.length > 0){
                let isAll = false;
                for(let i=0; i<this.searchParams.consult_status.length; i++){
                    if(this.searchParams.consult_status[i] == 0){
                        isAll = true;
                    }
                    
                    consult_status_str += this.searchParams.consult_status[i];
                    if(i < this.searchParams.consult_status.length - 1){
                        consult_status_str += '_';
                    }
                }
                if(isAll){
                    consult_status_str = '';
                }
            }

            //정산상태 검색 파라미터 _붙여서 보내기
            let settled_str = '';
            if(this.searchParams.settled && this.searchParams.settled.length > 0){
                let isAll = false;
                for(let i=0; i<this.searchParams.settled.length; i++){
                    if(this.searchParams.settled[i] == 2){
                        isAll = true;
                    }
                    settled_str += this.searchParams.settled[i];
                    if(i < this.searchParams.settled.length - 1){
                        settled_str += '_';
                    }
                }
                if(isAll){
                    settled_str = '';
                }
            }

            //상담 구분 검색 파라미터 _붙여서 보내기
            let what_is_str = '';
            if(this.searchParams.what_is && this.searchParams.what_is.length > 0){
                let isAll = false;
                for(let i=0; i<this.searchParams.what_is.length; i++){
                    if(this.searchParams.what_is[i] == 0){
                        isAll = true;
                    }
                    what_is_str += this.searchParams.what_is[i];
                    if(i < this.searchParams.what_is.length - 1){
                        what_is_str += '_';
                    }
                }
                if(isAll){
                    what_is_str = '';
                }
            }

            //검색 날짜 UTC로 변환 -> 다시 한국시간으로 보내기로함
            let date_start = ''
            let date_end = '';
            
            if(this.searchParams.date_start){
                //date_start = moment(this.searchParams.date_start).utc().format('YYYY-MM-DDTHH:mm:ss');
                date_start = moment(this.searchParams.date_start).format('YYYY-MM-DDTHH:mm:ss');
            }
            if(this.searchParams.date_end){
                //date_end = moment(this.searchParams.date_end).utc().format('YYYY-MM-DDTHH:mm:ss');
                date_end = moment(this.searchParams.date_end).format('YYYY-MM-DDTHH:mm:ss');
            }

            let params = {
                'consult_type': this.settle_type, //1. 전화처방, 2. 나머지
                
                'date_type': this.searchParams.date_type, //상담일자
                'consult_status': consult_status_str, //상담상태
                'settled': settled_str, //정산상태
                
                // 'date_start': this.searchParams.date_start, //검색기간 시작일
                // 'date_end': this.searchParams.date_end, //검색기간 종료일
                'date_start': date_start, //검색기간 시작일
                'date_end': date_end, //검색기간 종료일

                'search_type': this.searchParams.search ? this.searchParams.search_type : '', // 검색조건
                'search': this.searchParams.search ? this.searchParams.search : '', //이름
                'what_is': this.settle_type == 2 ? what_is_str : '',
            }
            let today = new Date();
            let month = today.getMonth() + 1;  // 월
            let date = today.getDate();  // 날짜
            let secure_key = (month + date) * 12;

            await this.axios({
                method: 'get',
                url: 'https://api-v2.mdtalk.io/settle/' + secure_key + '/detail/' + this.account.dr_id,
                params: params,
                headers: {'Authorization': 'Token 26c42293dd1fd5ed01320646e094196a827393f8'}
            }).then((response) => {
                this.bottom_settlements = response.data.resp;
            }).catch((error) => {
                console.log('error!: ', error);
            });
        },
        search(searchParams){            
            //자식 컴포넌트에서 검색 파라미터를 받아 this에 바인딩 해준다
            this.searchParams.date_type = searchParams.date_type;
            this.searchParams.consult_status = searchParams.consult_status;
            this.searchParams.settled = searchParams.settled;
            this.searchParams.date_start = searchParams.date_start;
            this.searchParams.date_end = searchParams.date_end;
            this.searchParams.search_type = searchParams.search_type;
            this.searchParams.search = searchParams.search;
            this.searchParams.what_is = searchParams.what_is;

            this.load_bottom_list();
        },
        async onSelectRow(settlement){
            //상단 리스트에서 row 클릭시 하단 row 데이터 범위 세팅후 로드
            this.chosen_settlement = settlement;

            let month = settlement.month;
            if(month.toString().length == 1){
                month = '0' + month;
            }
            let currentMonth = settlement.year + '-' + month;
            let startDate = moment(currentMonth).format('YYYY-MM-DD HH:mm:ss'); //해당 월의 1일
            let endDate = currentMonth + '-' + moment(currentMonth).daysInMonth() + ' 23:59:59'; //해당 월의 말일

            this.searchParams.date_start = startDate;
            this.searchParams.date_end = endDate;

            this.load_bottom_list();
        },
        reload_list(){
            //this.load_top_list(this.page_current);
        },
    },
  
    mounted() {
        this.load_top_list();
        //this.load_bottom_list();
    },
    watch: {
        '$route.params.settle_type' (settle_type){
            this.settle_type = settle_type;

            this.top_settlements = [];
            this.bottom_settlements = [];
            this.chosen_settlement = {};
            this.searchParams = {};


            this.load_top_list();
            //this.load_bottom_list();
            //this.$router.go(this.$router.currentRoute); //넘 느린듯 ...
        }
    },
    components: {
        SettleTopList, SettleBottomTelList, SettleBottomEtcList
    }
}

</script>

<style scoped>
    .wrap {
        width: 100%;
        max-width: 1400px;
        margin: 40px auto 40px;
    }

    .wrap h2 {
        font: 400 24px 'Noto Sans KR', sans-serif;
        margin-bottom: 20px;
    }
    
    .btn-group .cnt-group {
        color: #999;
        float: right;
        /* margin-top: 10px; */
        margin-right: 5px;
        margin-bottom: 5px;
        display: block;
    }

    .top {
        width: 100%;
        height: 100%;
        padding: 0 10px 10px 10px;
        float: left;
        margin-right: 10px;
        position: relative;
        border: 1px solid #e7e7e9;
        box-sizing: border-box;
        background-color: #fff;
    }

    .top-pager {
        position: absolute;
        left: 50%;
        bottom: 8px;
        transform: translateX(-50%);
    }

    .top-pager .pager-list,
    .top-pager .pager-next {
        float: left;
    }

    .top-pager .pager-list {
        font-size: 0;
    }

    .top-pager .pager-list > li {
        display: inline-block;
        width: 100%;
        height: 24px;
        cursor: pointer;
        margin-right: 20px;
        text-align: center;
        font: 400 13px/24px 'Noto Sans KR', sans-serif;
    }

    .top-pager .pager-list > li.on {
        border: 1px solid #736ee6;
    }

    .top-pager .pager-next {
        color: #c8c9cb;
        display: inline-block;
        width: 24px;
        height: 24px;
        cursor: pointer;
        text-align: center;
        border: 1px solid #c8c9cb;
        font: 400 14px/24px 'Roboto', sans-serif;
    }

    .top-pager .pager-btn {
        width: 5rem;
        height: 2rem;
        letter-spacing: 0.5px;
    }

    .bottom {
        width: 100%;
        /* height: 340px; */
        height: 100%;
        padding: 10px 10px 10px 10px;
        float: left;
        margin-top: 10px;
        margin-right: 10px;
        position: relative;
        border: 1px solid #e7e7e9;
        box-sizing: border-box;
        background-color: #fff;
    }

    .bottom .tab {
        width: 100%;
        height: 40px;
        font-size: 0;
        box-sizing: border-box;
        border-bottom: 1px solid #e7e7e9;
    }

    .bottom .tab > li {
        color: #b8b8b8;
        width: 100%;
        height: 40px;
        cursor: pointer;
        display: inline-block;
        text-align: center;
        box-sizing: border-box;
        font: 500 15px/40px 'Noto Sans KR', sans-serif;
    }

    .bottom .tab > li:hover {
        color: #736ee6;
        position: relative;
    }

    .bottom .tab > li:hover::after,
    .bottom .box {
        /* width: 100%; */
        /* height: 100%; */
        padding: 10px 10px 0;
        position: relative;
        box-sizing: border-box;
    }
</style>
